import * as React from 'react'
import { SVGProps } from 'react'

const SvgPiggyBank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.453 8.633a4.86 4.86 0 0 0-.73-.692l1.63-1.311a2.546 2.546 0 0 0-4.08.151c-.853-.227-1.828-.352-2.915-.352-4.5 0-7.072 2.142-7.072 4.821 0 1.092.428 2.096 1.24 2.9-.032.051-.06.105-.082.163l-.695 1.754a1 1 0 0 0 .382 1.205l.197.128a1 1 0 0 0 1.373-.273l1.044-1.53c.018-.025.034-.052.049-.079.996.354 2.19.553 3.564.553 1.295 0 2.431-.177 3.392-.494l.86 1.363a1 1 0 0 0 1.198.403l.22-.083a1 1 0 0 0 .59-1.27l-.597-1.68a4.31 4.31 0 0 0 1.072-1.454l.05.001h.572a1 1 0 0 0 1-1v-2.5a1 1 0 0 0-1-1h-.572a.997.997 0 0 0-.69.276Z"
      fill="#00D37E"
    />
    <path
      d="M4.055 9.861c-.094-.15-.065-.359.068-.461a6.783 6.783 0 0 1 2.724-1.264 6.362 6.362 0 0 1 2.937.076c.156.04.248.225.206.403-.042.178-.202.282-.359.242a5.853 5.853 0 0 0-2.68-.064 6.237 6.237 0 0 0-2.486 1.148.277.277 0 0 1-.41-.08Z"
      fill="#fff"
    />
    <circle cx={5.25} cy={4.179} fill="#00D37E" r={3.75} />
    <path
      d="m5.51 3.944-.68.182c-.3.08-.601-.071-.673-.338-.071-.266.114-.549.414-.63l1.359-.363c.263-.07.425-.317.362-.551-.063-.234-.326-.367-.59-.296l-.543.145-.13-.483c-.062-.234-.326-.367-.588-.296-.263.07-.425.317-.363.55l.131.49c-.744.265-1.189.996-1.003 1.69.196.733 1.027 1.15 1.851.93l.68-.183c.3-.08.601.072.673.338.071.267-.115.55-.414.63l-1.36.364c-.262.07-.424.317-.361.55.062.235.326.367.589.297l.543-.146.13.484c.063.234.326.366.59.296.262-.07.424-.317.361-.551l-.13-.49c.744-.265 1.189-.996 1.003-1.689-.197-.733-1.027-1.15-1.851-.93Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.935 1.903c-.087-.328.142-.645.467-.732.326-.087.683.072.77.4l.092.341.4-.107c.326-.087.683.073.771.4.088.329-.141.646-.467.733l-1.359.364c-.237.063-.355.275-.309.448.046.173.255.297.492.233l.68-.182c.887-.237 1.81.207 2.032 1.035.198.74-.242 1.495-.97 1.816l.097.363c.088.328-.141.645-.467.732-.325.087-.682-.073-.77-.4l-.091-.342-.4.108c-.326.087-.683-.073-.771-.4-.088-.329.141-.646.467-.733l1.359-.364c.236-.064.355-.276.309-.448-.047-.173-.255-.297-.492-.234l-.68.182c-.887.238-1.81-.207-2.032-1.034-.198-.74.242-1.495.97-1.816l-.098-.363Zm.544-.446c-.2.053-.295.23-.258.37l.167.62-.129.047c-.686.244-1.072.907-.91 1.51.171.64.908 1.03 1.67.826l.68-.182c.362-.097.757.082.854.443.096.36-.156.713-.519.81l-1.359.365c-.2.053-.295.23-.257.37.037.14.208.244.408.19l.686-.183.168.627c.037.14.208.244.408.19.2-.053.295-.229.257-.369L6.18 6.47l.128-.046c.687-.245 1.073-.907.911-1.511-.171-.64-.909-1.03-1.67-.826l-.68.182c-.362.097-.757-.082-.854-.442-.096-.361.156-.714.519-.811l1.358-.364c.2-.054.296-.23.258-.37-.037-.14-.208-.245-.408-.191l-.686.184-.168-.627c-.038-.14-.208-.245-.408-.191Z"
      fill="#fff"
    />
  </svg>
)

export default SvgPiggyBank
